import React        from 'react';
import Flux         from '../../../../../flux/Flux';
import Translations from '../../../../../utils/Translations';

const DailybonusVipOfferDescr = () => (
	<div>
		<div className='dailybonus__mobile--item__description -margin-top-10 font-size-sm'>{Translations.get('BadgeExclusive')}</div>
		<div className='dailybonus__mobile--item__description -margin-top-10 font-size-sm'>
			{Flux.Guest.isVip() ? Translations.get('Wallpaper') : Translations.get('YearstadayBonusBecomeVIP')}
		</div>
	</div>
);

export default DailybonusVipOfferDescr;